/**
 * 旧版曾把资金密码明文放进 sessionStorage 做本地比对，现已改走 verify 接口。
 * 仍读一次是为兼容未退出的旧会话；退出时清掉。
 */
export const FUND_PWD_SESSION_KEY = 'sec-fund-pwd'
export const FUND_SET_SESSION_KEY = 'sec-fund-password-set'
const FUND_PWD_STORAGE_KEY = 'gamefi:fund-pwd'

export function readFundPwdSession(): string {
  const state = useState(FUND_PWD_SESSION_KEY, () => '')
  if (state.value) return state.value
  if (!import.meta.client) return ''
  try {
    const stored = sessionStorage.getItem(FUND_PWD_STORAGE_KEY) || ''
    if (stored) state.value = stored
    return stored
  } catch {
    return ''
  }
}

export function clearFundPwdSession() {
  useState(FUND_PWD_SESSION_KEY, () => '').value = ''
  useState(FUND_SET_SESSION_KEY, () => false).value = false
  if (!import.meta.client) return
  try {
    sessionStorage.removeItem(FUND_PWD_STORAGE_KEY)
  } catch {
    /* private mode 等忽略 */
  }
}

/**
 * 用 /me.fund_password_set 同步本地开关。
 * - trustMeOnly：登录场景，以服务端为准
 * - 否则：服务端 true，或本地已是 true / 本会话刚设过，都视为已设置（避免 Redis 缓存未刷把 UI 打回未设置）
 */
export function applyFundPasswordFromMe(
  fundPasswordSet: boolean,
  options?: { trustMeOnly?: boolean },
) {
  const userStore = useUserStore()
  const fromMe = !!fundPasswordSet
  const hasFund = options?.trustMeOnly
    ? fromMe
    : fromMe || userStore.user.hasFundPassword || !!readFundPwdSession()

  userStore.setProfile({ hasFundPassword: hasFund })
  useState(FUND_SET_SESSION_KEY, () => false).value = hasFund
  return hasFund
}
